import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

import '../styles/empty-state.css';

class EmptyState extends Component {
  handleButtonClick() {
    const { callback, secondAction } = this.props;

    if (callback) {
      callback();
    }

    if (secondAction) {
      secondAction();
    }
  }
  render() {
    const { t } = this.context;
    const { title, translationsObject, actionButtonLabel, callback } = this.props;

    return (
      <div className="empty-state-container">
        <div className="empty-state-container__wrapper">
          <span className="glyphicon glyphicon-minus-sign" />
          <RenderIf if={title}>
            <p className="empty-state-container__wrapper__message m-t-20">{t(title, translationsObject || {})}</p>
          </RenderIf>
          <RenderIf if={actionButtonLabel && callback}>
            <div className="transparent-btn m-t-20" onClick={() => this.handleButtonClick()}>
              {t(actionButtonLabel)}
            </div>
          </RenderIf>
        </div>
      </div>
    );
  }
}

EmptyState.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/app/shared/empty-state/components/empty-state.js